import { Bloodwork } from '../models/Bloodwork';

/**
 * Whether two props updates are pointed at the SAME test.
 *
 * Every panel on the analysis report that holds an editable draft in local
 * state needs this. The screen keeps ONE BloodworkTestAnalysis mounted and
 * swaps its `bloodwork` prop when the practitioner clicks Analyze on another
 * row, so a panel that only reseeds on mount goes on showing the previous
 * test's text — and its Save writes that text over the new test's own note.
 *
 * Compared by id rather than object identity, because BloodworkAnalysis builds
 * its own copy of the test (`new Bloodwork(...)`) every time it re-analyzes:
 * same test, new object, and unsaved typing has to survive that. A test with no
 * id yet (never saved) falls back to object identity.
 */
export function isSameBloodwork(a?: Bloodwork, b?: Bloodwork): boolean {
  if (!a || !b) {
    return a === b;
  }
  if (a.id || b.id) {
    return a.id === b.id;
  }
  return a === b;
}
